module.exports = __webpack_public_path__ + "img/DI.d8ae4d35.png";